import {STATUS} from '@/data/survey'

export function getStatus(startDate, endDate){
  if(startDate == null ||
    typeof startDate === 'undefined' ||
    startDate === ''){
      return STATUS.STANDBY
    }

  if(endDate == null ||
  typeof endDate === 'undefined' ||
  endDate === ''){
    return STATUS.ONGOING
  }

  const now = new Date()
  var startObj = new Date(startDate)
  var endObj = new Date(endDate)

  if(startObj.getTime() <= now.getTime() && now.getTime() <= endObj.getTime()){
    return STATUS.ONGOING
  }


  if(now.getTime() > endObj.getTime()){
    return STATUS.COMPLETED
  }
}